import React from 'react';
import { FaDollarSign } from 'react-icons/fa';
import './TotalAmountCard.scss';

function TotalAmountCard({ orders, title = "Total Purchases" }) {
  // Calculate total amount from completed orders
  const totalAmount = orders
    .filter(order => order.status === 'completed')
    .reduce((sum, order) => sum + (parseFloat(order.totalPrice) || 0), 0);

  // Format the total amount as currency
  const formattedTotal = totalAmount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return (
    <div className="total-amount-card">
      <div className="amount-icon">
        <FaDollarSign />
      </div>
      <div className="amount-details">
        <h3>{title}</h3>
        <div className="amount-value">{formattedTotal}</div>
      </div>
    </div>
  );
}

export default TotalAmountCard;